import {types} from './constants';

export const toggleDashboard = () => ({
  type: types.TOGGLE_DASHBOARD,
});
